<template>
  <div>
    <div class="m_flex_row" style="margin:30px">
      单位名称：
      <a-input
        placeholder="请输入单位名称"
        @change="nameChange"
        v-model="key"
        style="width:300px;margin-left:20px;margin-right:100px;"
      />

      <a-button type="primary" icon="search" style="margin-right:50px">搜索</a-button>

      <a-button type="primary" icon="plus" @click="goAddProject">创建单位</a-button>
    </div>

    <a-table :columns="columns" :dataSource="data" bordered :pagination="false">
      

      <template slot="people_count" slot-scope="text, record,index">
        <a @click="() => goPeopleList(record.key)">{{text}}</a>
      </template>

      <template slot="operation" slot-scope="text, record">
        <a @click="() => edit(record.key)">编辑</a>
        <a-divider type="vertical" />
        <a-divider type="vertical" />
        <a-popconfirm
          title="确定删除吗?"
          @confirm="() => onDelete(record.key)"
        >
          <a href="javascript:;">删除</a>
        </a-popconfirm>
      </template>
    </a-table>
    <div style="text-align:center;margin-top:30px;">
      <a-pagination :total="total" @change="changePage" show-less-items />
    </div>
  </div>
</template>
<script>
import request from "../../utils/request";
const columns = [
  {
    title: "序号",
    dataIndex: "the_id",
    width: "10%"
  },
  {
    title: "单位名称",
    dataIndex: "name",
    width: "30%"
  },
  {
    title: "单位编号",
    dataIndex: "code",
    width: "10%"
  },
  {
    title: "创建时间",
    dataIndex: "create_time",
    width: "10%"
  },
  {
    title: "操作",
    width: "20%",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" }
  }
];

export default {
  data() {
    return {
      total: 0,
      current_page: 0,
      data: [],
      columns,
      key: ""
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    changePage(page, pageSize) {
      this.current_page = page - 1;
      console.log(page, pageSize, this.current_page);
      this.getData();
    },
    nameChange(e) {
      console.log(this.key, e);
      this.getData();
    },
    goAddProject() {
      this.$router.push({
        path: "/unit/add"
      });
    },
    getData() {
      request({
        url: "/edc_unit/all",
        method: "get",
        params: {
          page: this.current_page,
          page_size: 10,
          key: this.key
        }
      }).then(response => {
       
        if (response.data.success) {
          const list = response.data.data;
          let i = this.current_page * 10 + 1;

          this.data = list.map(item => {
            item["the_id"] = i;
            i += 1;
            return item;
          });
           console.log("获取到的参数", this.data);
          this.total = response.data.total;
        } else {
          this.$message.error(response.data.msg);
        }
      });
    },
    onDelete(key) {
      request({
        url: "/edc_unit/eic/delete",
        method: "post",
        data: {
          unit_id:key
        }
      }).then(response => {
        if (response.data.success) {
          this.getData();
        } else {
          this.$message.error(response.data.msg);
        }
      });
    },
    
    edit(key) {
      this.$router.push({ path: "/unit/add", query: { the_id: key } });
    },
    save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter(item => key === item.key)[0];
      const targetCache = newCacheData.filter(item => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter(item => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    }
  }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style>